import { Badge } from "@chakra-ui/react";

const BadgeFormStatus = ({ data }) => {
    let color = "gray"
    switch (data.form_status_id) {
        case 1: color = "gray"; break;
        case 2: color = "linkedin"; break;
        case 3: color = "orange"; break;
        case 4: color = "green"; break;
        case 5: color = "red"; break;
        default: color = "gray"
    }

    return (
        <Badge colorScheme={color}>{data.form_status_name}</Badge>
    )
}

export default BadgeFormStatus